<template lang="pug">
#information-list(v-cloak)
  .box
    .box-header.with-border.register-header
      .title
        span お知らせ・操作履歴
    .box-body
      b-tabs
        //- notifications
        b-tab.tab
          template(v-slot:title)
            .tab-title
              span お知らせ
          .mb-3
          NotificationTable
        //- function histories
        b-tab.tab(v-if="showFunctionHistory")
          template(v-slot:title)
            .tab-title
              span 操作履歴
          FunctionHistoryTab
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

import { userStore } from "@/store/store";

import NotificationTable from "@/pc/containers/notifications/NotificationTable.vue";
import FunctionHistoryTab from "@/pc/containers/notifications/FunctionHistoryTab.vue";

/**
 * お知らせ画面コンポーネント
 */
@Component({
  components: {
    NotificationTable,
    FunctionHistoryTab
  }
})
export default class NotificationList extends Vue {
  /**
   * ### 操作履歴の表示可否
   */
  public showFunctionHistory(): boolean {
    return userStore.user.permissions.functions.waitersFunction;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

// 親要素からネストしてスタイルを指定する
#information-list {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}
</style>
